import { FormatValue } from "../model/types";
import { useDateFormatter } from "@/shared/formatters";
import { useTranslations } from "use-intl";

export function DateFormatter({ value }: { value: FormatValue }) {
  const format = useDateFormatter();
  const t = useTranslations("Common");

  return (
    <span className={"whitespace-nowrap"}>
      {value === null || value === undefined
        ? t("Not specified")
        : format(value)}
    </span>
  );
}
